export default __webpack_public_path__ + "locales/nl/Webhooks.json?hash=241af302193bd93c8c080f3e128ce58c";